import { homeSecurityPortalApi } from 'data/axios';
import {
  TPaymentMethodsList,
  TPurchasePayload,
  TTransactionList
} from 'typings';
import { ApiResponse } from './HttpRequest';
import { endpoints } from './endpoints';

export async function GetPaymentMethods(): Promise<
  ApiResponse<TPaymentMethodsList>
> {
  const response = await homeSecurityPortalApi.get(endpoints.paymentMethodsUrl);
  return response;
}

export async function DeletePaymentMethod(
  paymentMethodId: string
): Promise<ApiResponse<{ message: string }>> {
  const response = await homeSecurityPortalApi.delete(
    endpoints.deletePaymentMethodUrl(paymentMethodId)
  );
  return response;
}

export async function UpdateDefaultPaymentMethod(
  paymentMethodId: string
): Promise<ApiResponse<{ message: string }>> {
  const response = await homeSecurityPortalApi.put(
    endpoints.updateDefaultPaymentMethodUrl(paymentMethodId)
  );
  return response;
}

export async function PaymentSetupIntent() {
  try {
    const response = await homeSecurityPortalApi.post(endpoints.setupIntentUrl);
    return response;
  } catch (error) {
    console.error('Error fetching invoice link:', error);
    throw error;
  }
}

export async function GetAllTransaction(): Promise<
  ApiResponse<TTransactionList>
> {
  const response = await homeSecurityPortalApi.get(
    endpoints.getTransactionsUrl
  );
  return response;
}

export async function GetInvoiceDownloadLink(transactionId: string) {
  try {
    const response = await homeSecurityPortalApi.get(
      endpoints.billings(transactionId)
    );
    return response;
  } catch (error) {
    console.error('Error fetching invoice link:', error);
    throw error;
  }
}

export async function CreatePurchaseId(payload: TPurchasePayload) {
  try {
    const response = await homeSecurityPortalApi.post(
      endpoints.createPurchaseIdUrl,
      payload
    );
    return response;
  } catch (error) {
    console.error('Error creating purchase ID:', error);
    throw error;
  }
}

export async function GetProRataCharge(purchaseId: string) {
  try {
    const response = await homeSecurityPortalApi.get(
      endpoints.prorateCharge(purchaseId)
    );
    return response;
  } catch (error) {
    console.error('Error fetching pro-rata charge:', error);
    throw error;
  }
}
